export const CREW_DAILY_CHALLENGE_PENDING_KEY = 'gweffit_crew_daily_challenge_pending';

export function setCrewDailyChallengePending(crew) {
  if (!crew?.crew_id) return;
  try {
    localStorage.setItem(
      CREW_DAILY_CHALLENGE_PENDING_KEY,
      JSON.stringify({
        crew_id: crew.crew_id,
        crew_name: crew.crew_name || 'your crew',
        ts: Date.now(),
      })
    );
  } catch {}
}

export function peekCrewDailyChallengePending() {
  try {
    const raw = localStorage.getItem(CREW_DAILY_CHALLENGE_PENDING_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function consumeCrewDailyChallengePending() {
  try {
    const raw = localStorage.getItem(CREW_DAILY_CHALLENGE_PENDING_KEY);
    if (!raw) return null;
    localStorage.removeItem(CREW_DAILY_CHALLENGE_PENDING_KEY);
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}
